import { MECHANICAL_TAGS } from '../tracking/tracking.conditions';

import cookieHelper from './utils.cookie';

const INTERIOR_SUB_TABS = ['seats-carpet-headliner', 'dashboard-lights'];
export const isInteriorLinkText = (linkText: string) => INTERIOR_SUB_TABS.includes(linkText);

export const getSubnavLinkText = (label: string) => label.replace('button::subnav::', '').replace(/_/g, '-');

export const isMechanicalLabel = (label: string) => Object.values(MECHANICAL_TAGS).includes(label);

export const getPixallDataFromCookies = (fallbackPixallId = '', fallbackPixallRealId = '', fallbackIncludePixall = false) => {
  const pixallIdCookie = cookieHelper.get('abc') || cookieHelper.get('pxa_id') || '';
  const pixallRealIdCookie = cookieHelper.get('pxa_realid') || '';

  const validatedPixallId = pixallIdCookie && pixallIdCookie.match(/[^A-Z0-9]/gi) ? '' : pixallIdCookie;
  const validatedPixallRealId = pixallRealIdCookie && pixallRealIdCookie.match(/[^A-Z0-9]/gi) ? '' : pixallRealIdCookie;

  const finalPixallId = validatedPixallId || fallbackPixallId;
  const finalPixallRealId = validatedPixallRealId || fallbackPixallRealId;
  const finalIncludePixall = !!validatedPixallId ? true : fallbackIncludePixall;

  return {
    pixallId: finalPixallId,
    pixallRealId: finalPixallRealId,
    hasPixallCookie: !!validatedPixallId,
    includePixall: finalIncludePixall,
  };
};
